import { TextStyle } from 'react-native';

import colors from './colors';

const typography: { [key: string]: TextStyle } = {
  title01: {
    fontSize: 28,
    fontWeight: 'bold',
    letterSpacing: 0.48,
    lineHeight: 34,
    color: colors.greyDark,
  },
  title02: {
    fontSize: 24,
    fontWeight: 'bold',
    lineHeight: 30,
    color: colors.greyDark,
  },
  title03: {
    fontSize: 22,
    fontWeight: 'bold',
    lineHeight: 30,
    color: colors.greyDark,
  },
  title04: {
    fontSize: 16,
    fontWeight: 'bold',
    color: colors.greyDark,
  },
  title05: {
    fontSize: 20,
    fontWeight: '700',
    lineHeight: 24,
    color: colors.greyDark,
  },
  body: {
    fontSize: 16,
    fontWeight: '300',
    lineHeight: 24,
    color: colors.greyDark,
  },
  bodyBold: {
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: 24,
    color: colors.greyDark,
  },
  bodyRed: {
    fontSize: 16,
    fontWeight: '300',
    lineHeight: 24,
    color: colors.red,
  },
  caption: {
    fontSize: 14,
    fontWeight: '300',
    lineHeight: 20,
    color: colors.greyDark,
  },
  caption01: {
    fontSize: 13,
    fontWeight: 'bold',
    lineHeight: 16,
    color: colors.greyDark,
  },
  caption02: {
    fontSize: 13,
    fontWeight: '300',
    lineHeight: 16,
    color: colors.greyDark,
  },
  caption03: {
    fontSize: 11,
    fontWeight: '300',
    lineHeight: 14,
    color: colors.greyDark,
  },
  captionBold: {
    fontSize: 14,
    fontWeight: 'bold',
    lineHeight: 20,
    color: colors.greyDark,
  },
  captionRed: {
    fontSize: 14,
    fontWeight: '300',
    lineHeight: 20,
    color: colors.red,
  },
  button: {
    fontSize: 16,
    fontWeight: 'bold',
    color: colors.greyDark,
  },
  buttonWhite: {
    fontSize: 16,
    fontWeight: 'bold',
    color: colors.white,
  },
  inputLabel: {
    fontSize: 13,
    fontWeight: 'bold',
    color: colors.grey,
  },
  link: {
    fontSize: 13,
    textDecorationLine: 'underline',
    color: colors.pink,
  },
  linkBold: {
    fontSize: 13,
    fontWeight: 'bold',
    textDecorationLine: 'underline',
    color: colors.pink,
  },
  smallText: {
    fontWeight: '600',
    fontSize: 10,
    lineHeight: 13,
  },
  tiny: {
    fontWeight: '400',
    fontSize: 9,
    lineHeight: 12,
  },
};

export default typography;
